const REMOVED_TAGS = new Set([
  "SCRIPT",
  "STYLE",
  "IFRAME",
  "OBJECT",
  "EMBED",
  "FORM",
  "INPUT",
  "BUTTON",
  "TEXTAREA",
  "SELECT",
  "LINK",
  "META",
]);

const ALLOWED_LINK_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];
const ELEMENT_NODE_TYPE = 1;

function sanitizeNode(node) {
  if (!node || !node.childNodes) {
    return;
  }

  const children = Array.from(node.childNodes);
  children.forEach((child) => {
    if (child.nodeType === ELEMENT_NODE_TYPE) {
      if (REMOVED_TAGS.has(child.tagName)) {
        child.remove();
        return;
      }

      Array.from(child.attributes).forEach((attribute) => {
        const attributeName = attribute.name.toLowerCase();
        const attributeValue = attribute.value ? attribute.value.trim() : "";

        if (attributeName.startsWith("on")) {
          child.removeAttribute(attribute.name);
          return;
        }

        if (attributeName === "style") {
          child.removeAttribute(attribute.name);
          return;
        }

        if (attributeName === "href") {
          try {
            const origin = window && window.location && window.location.origin
              ? window.location.origin
              : "http://localhost";
            const parsed = new URL(attributeValue, origin);
            if (!ALLOWED_LINK_PROTOCOLS.includes(parsed.protocol)) {
              child.removeAttribute(attribute.name);
            }
          } catch (error) {
            child.removeAttribute(attribute.name);
          }
          return;
        }

        if (attributeName !== "href" && attributeName !== "target" && attributeName !== "rel") {
          child.removeAttribute(attribute.name);
        }
      });

      if (child.tagName === "A") {
        child.setAttribute("rel", "noopener noreferrer");
      }
    }

    sanitizeNode(child);
  });
}

export function sanitizeHtml(rawHtml) {
  if (!rawHtml) {
    return "";
  }

  if (!document) {
    return String(rawHtml);
  }

  const template = document.createElement("template");
  template.innerHTML = rawHtml;
  sanitizeNode(template.content);
  return template.innerHTML;
}

export function sanitizeRichText(rawText) {
  if (!rawText) {
    return "";
  }

  const withBreaks = String(rawText).replace(/\\n/g, "<br />").replace(/\n/g, "<br />");
  return sanitizeHtml(withBreaks);
}
